import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';
import { colors } from '@bitcoin-portal/verse-web-components/dist/themes/colors';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  box-sizing: border-box;

  max-width: 100vw;
  width: 100%;
  overflow: visible;
`;

export const TitleWrapper = styled.div`
  padding: 0 16px;

  & > h3 {
    text-transform: uppercase;
  }
`;

export const ContentWrapper = styled.div`
  padding: 17px 16px;
  display: grid;
  row-gap: 11px;

  ${media.sm`
    row-gap: 16px;
    column-gap: 16px;
    grid-template-columns: 1fr 1fr;
  `}

  & > a {
    overflow: hidden;
    background: radial-gradient(${colors.shade20}, ${colors.shade20})
        padding-box,
      linear-gradient(to right, #141d2b, #273953, #141d2b) border-box;
    border: 1px solid transparent;

    &::after {
      background: linear-gradient(
            ${colors.verseNavBlue},
            ${colors.verseNavBlue}
          )
          padding-box,
        linear-gradient(to right, #141d2b, #273953, #141d2b) border-box;
    }
  }
`;
